import React from 'react'
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import '../App.css';


function GenerarPdf({factura,total,envio,envioName,carrito}) { 

    const Direccion = JSON.parse(localStorage.getItem('Direccion'));

    let sumaTotal = total+envio;

    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
    const date2 = `${current.getDate()}/${current.getMonth()+2}/${current.getFullYear()}`;
    
    return(
        <Document>
            <Page
                size='A3'
               style={{padding: 20}}
            >
                <View style={{display: 'flex', fontSize: "17px", paddingBottom:10, justifyContent:'space-between',flexDirection: "row",alignItems:'center', borderBottom:'3pt solid #fb8cff;'}}>
                    <Image
                        src={require('../assets/images/logo-shabless.jpg')}
                        alt="random image"
                        style={{ Width: "111px", height:'111px' }}
                    />
                    <View style={{display: 'flex',flexDirection: "column"}}>
                        <Text style={{alignSelf:'flex-end'}}>ShaBless,</Text>
                        <Text style={{alignSelf:'flex-end'}}>11706, Santo Domingo, Dominican Republic,</Text>
                        <Text style={{alignSelf:'flex-end'}}>Distrito Nacional</Text>
                    </View>
                </View>
                <Text style={{ color: "#fb8cff", fontSize: "25px", padding:'20px 0' }}>
                    Factura {factura}
                </Text>
                <View style={{display: 'flex',flexDirection: "row"}}>
                    <View style={{marginRight:120}}>
                        <Text style={{ color: "#6f3d71", fontSize: "18px", padding:'5px 0' }}>
                            Fecha de factura:
                        </Text>
                        <Text style={{ fontSize: "16px"}}>
                            {date}
                        </Text>
                    </View>
                    <View>
                        <Text style={{ color: "#6f3d71", fontSize: "18px", padding:'5px 0' }}>
                            Fecha de vencimiento:
                        </Text>
                        <Text style={{ fontSize: "16px"}}>
                            {date2}
                        </Text>
                    </View>
                </View>
                <Text style={{ fontSize: "20px", color: "#6f3d71", padding:'10px 0'}}>
                    Enviar a:
                </Text>
                <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    textAlign:'center',
                    alignItems: "center",
                    border: '2px solid #6f3d71',
                    padding: 8,
                    
                }}
                >
                    <Text style={{width:'20%', color: "#6f3d71"}}>Nombre</Text>
                    <Text style={{width:'20%', color: "#6f3d71"}}>Enviar por</Text>
                    <Text style={{width:'20%', color: "#6f3d71"}}>Ciudad</Text>
                    <Text style={{width:'20%', color: "#6f3d71"}}>Sector</Text>
                    <Text style={{width:'20%', color: "#6f3d71"}}>Calle</Text>
                </View>
                <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    textAlign:'center',
                    alignItems: "center",
                    border: '2px solid #6f3d71',
                    borderTop: 'none',
                    padding: 8,
                    
                }}
                >
                    <Text style={{width:'20%'}}>{Direccion.Nombre}</Text>
                    <Text style={{width:'20%'}}>{envioName}</Text>
                    <Text style={{width:'20%'}}>{Direccion.Ciudad}</Text>
                    <Text style={{width:'20%'}}>{Direccion.Sector}</Text>
                    <Text style={{width:'20%'}}>{Direccion.Calle}</Text>
                </View>
                <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent:'space-between',
                    alignItems: "center",
                    border: '2px solid #6f3d71',
                    borderTop: 'none',
                    padding: 8,
                    
                }}
                >
                    <Text style={{color: "#6f3d71"}}>Telefono:</Text>
                    <Text>{Direccion.Telefono}</Text>
                </View>
                <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent:'space-between',
                    alignItems: "center",
                    border: '2px solid #6f3d71',
                    borderTop: 'none',
                    padding: 8,
                    
                }}
                >
                    <Text style={{color: "#6f3d71"}}>Correo:</Text>
                    <Text>{Direccion.Email}</Text>
                </View>
                <Text style={{ textAlign: "center", marginTop: "22px",fontSize: "24px",justifyContent: "center", alignItems:'center' }}>
                    {Direccion.Referencia}
                </Text>
                <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    textAlign:'center',
                    alignItems: "center",
                    border: '2px solid #6f3d71',
                    marginTop: 30,
                    padding: 8,
                    
                }}
                >
                    <Text style={{width:'35%', color: "#6f3d71"}}>Producto</Text>
                    <Text style={{width:'15%', color: "#6f3d71"}}>Cantidad</Text>
                    <Text style={{width:'25%', color: "#6f3d71"}}>Precio Unitario</Text>
                    <Text style={{width:'25%', color: "#6f3d71"}}>Total</Text>
                </View>
               
                {carrito.map((c)=>{
                    return(
                        <View
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                textAlign:'center',
                                alignItems: "center",
                                border: '2px solid #6f3d71',
                                borderTop: 'none',
                                padding: 8,
                                
                            }}
                        >
                            <Text style={{width:'35%'}}>{c.Title}</Text>
                            <Text style={{width:'15%'}}>{c.Quantity}</Text>
                            <Text style={{width:'25%'}}>{c.Price.toLocaleString("en", { style: "currency", "currency": "DOP" })}</Text>
                            <Text style={{width:'25%'}}>$RD {c.Quantity*c.Price}.00</Text>
                        </View>
                    )
                })}

                <View style={{padding:'20px 0',alignSelf:'flex-end'}}>
                    <View style={{display:'flex',flexDirection:'row',border: '2px solid #6f3d71'}}>
                        <Text style={{width:'300px',borderRight: '2px solid #6f3d71',padding:'7px'}}>
                            Subtotal
                        </Text>
                        <Text style={{width:'200px',padding:'7px',textAlign:'right'}}>
                           {total.toLocaleString("en", { style: "currency", "currency": "DOP" })}
                        </Text>
                    </View>
                    <View style={{display:'flex',flexDirection:'row',border: '2px solid #6f3d71',borderTop:'none'}}>
                        <Text style={{width:'300px',borderRight: '2px solid #6f3d71',padding:'7px'}}>
                            Entrega
                        </Text>
                        <Text style={{width:'200px',padding:'7px',textAlign:'right'}}>
                            {envio.toLocaleString("en", { style: "currency", "currency": "DOP" })}
                        </Text>
                    </View>
                    <View style={{display:'flex',flexDirection:'row',backgroundColor:'#4a2a4b85',border: '2px solid #6f3d71',borderTop:'none'}}>
                        <Text style={{width:'300px',borderRight: '2px solid #6f3d71',padding:'7px'}}>
                            Total
                        </Text>
                        <Text style={{width:'200px',padding:'7px',textAlign:'right'}}>
                            {sumaTotal.toLocaleString("en", { style: "currency", "currency": "DOP" })}
                        </Text>
                    </View>
                </View>
            </Page>
        </Document>
    )
    
}

export default GenerarPdf;